<template>
  <div class="capital-cash-flow">
    <!-- 资本金现金流量表 -->
    <div class="table-wrapper">
      <div class="table-scroll-area">
        <table class="profit-table">
          <thead>
            <tr>
              <th>序号</th>
              <th>项 目</th>
              <th>合计</th>
              <th
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'header-' + index"
              >
                {{ index }}
              </th>
            </tr>
            <tr>
              <th class="seq-col"></th>
              <th style="text-align: center">建设期/经营期</th>
              <th class="total-col"></th>
              <th
                :colspan="localCashFlowData.constructionPeriod"
                style="font-size: 12px; color: #666; text-align: center"
              >
                建设期
              </th>
              <th
                :colspan="
                  localCashFlowData.calculationPeriod -
                  localCashFlowData.constructionPeriod
                "
                style="font-size: 12px; color: #666; text-align: center"
              >
                经营期
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- 现金流入 -->
            <tr>
              <td class="seq-col">1</td>
              <td class="item-col">现金流入</td>
              <td class="total-col">
                {{
                  formatNumber(
                    localCashFlowData?.cashFlow?.cashInflowTotal || 0
                  )
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'cash-inflow-' + index"
              >
                {{
                  formatNumber(
                    (localCashFlowData?.cashFlow?.cashInflowByYear || [])[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">1.1</td>
              <td class="item-col">营业收入</td>
              <td class="total-col">
                {{
                  formatNumber(localCashFlowData.cashFlow.operatingRevenueTotal)
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'operating-revenue-' + index"
              >
                {{
                  formatNumber(
                    (localCashFlowData.cashFlow.operatingRevenueByYear || [])[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">1.2</td>
              <td class="item-col">补贴收入</td>
              <td class="total-col">
                {{
                  formatNumber(localCashFlowData.cashFlow.subsidyIncomeTotal)
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'subsidy-income-' + index"
              >
                {{
                  formatNumber(
                    (localCashFlowData.cashFlow.subsidyIncomeByYear || [])[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
            <tr>
              <td class="seq-col">1.3</td>
              <td class="item-col">其他流入</td>
              <td class="total-col">
                {{
                  formatNumber(localCashFlowData.cashFlow.otherCashInflowTotal)
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'other-cash-inflow-' + index"
              >
                {{
                  formatNumber(
                    (localCashFlowData.cashFlow.otherCashInflowByYear || [])[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
            <!-- 回收固定资产余值 -->
            <tr>
              <td class="seq-col">1.4</td>
              <td class="item-col">回收固定资产余值</td>
              <td class="total-col">
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.recoveryFixedAssetsTotal
                  )
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'recovery-fixed-assets-' + index"
              >
                {{
                  formatNumber(
                    (localCashFlowData.cashFlow.recoveryFixedAssetsByYear ||
                      [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <!-- 回收流动资金 -->
            <tr>
              <td class="seq-col">1.5</td>
              <td class="item-col">回收流动资金</td>
              <td class="total-col">
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.recoveryWorkingCapitalTotal
                  )
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'recovery-working-capital-' + index"
              >
                {{
                  formatNumber(
                    (localCashFlowData.cashFlow.recoveryWorkingCapitalByYear ||
                      [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>

            <!-- 现金流出 -->
            <tr>
              <td class="seq-col">2</td>
              <td class="item-col">现金流出</td>
              <td class="total-col">
                {{ formatNumber(localCashFlowData.cashFlow.cashOutflowTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'cash-outflow-' + index"
              >
                {{
                  formatNumber(
                    (localCashFlowData.cashFlow.cashOutflowByYear || [])[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
            <!-- 项目资本金投入 -->
            <tr>
              <td class="seq-col">2.1</td>
              <td class="item-col">项目资本金投入</td>
              <td class="total-col">
                {{
                  formatNumber(localCashFlowData.cashFlow.equityInvestmentTotal)
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'equity-investment-' + index"
              >
                {{
                  formatNumber(
                    (localCashFlowData.cashFlow.equityInvestmentByYear || [])[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
            <!-- 借款本金偿还 -->
            <tr>
              <td class="seq-col">2.2</td>
              <td class="item-col">借款本金偿还</td>
              <td class="total-col">
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.debtPrincipalRepaymentTotal
                  )
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'debt-principal-repayment-' + index"
              >
                {{
                  formatNumber(
                    (localCashFlowData.cashFlow.debtPrincipalRepaymentByYear ||
                      [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <!-- 借款利息支付 -->
            <tr>
              <td class="seq-col">2.3</td>
              <td class="item-col">借款利息支付</td>
              <td class="total-col">
                {{
                  formatNumber(localCashFlowData.cashFlow.interestExpenseTotal)
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'interest-expense-' + index"
              >
                {{
                  formatNumber(
                    (localCashFlowData.cashFlow.interestExpenseByYear || [])[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
            <!-- 经营成本 -->
            <tr>
              <td class="seq-col">2.4</td>
              <td class="item-col">经营成本</td>
              <td class="total-col">
                {{
                  formatNumber(localCashFlowData.cashFlow.operatingCostTotal)
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'operating-cost-' + index"
              >
                {{
                  formatNumber(
                    (localCashFlowData.cashFlow.operatingCostByYear || [])[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
            <!-- 销售税金及附加 -->
            <tr>
              <td class="seq-col">2.5</td>
              <td class="item-col">销售税金及附加</td>
              <td class="total-col">
                {{ formatNumber(localCashFlowData.cashFlow.salesTaxTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'sales-tax-' + index"
              >
                {{
                  formatNumber(
                    (localCashFlowData.cashFlow.salesTaxByYear || [])[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
            <!-- 增值税 -->
            <tr>
              <td class="seq-col">2.6</td>
              <td class="item-col">增值税</td>
              <td class="total-col">
                {{ formatNumber(localCashFlowData.cashFlow.vatTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'vat-' + index"
              >
                {{
                  formatNumber(
                    (localCashFlowData.cashFlow.vatByYear || [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>
            <!-- 所得税 -->
            <tr>
              <td class="seq-col">2.7</td>
              <td class="item-col">所得税</td>
              <td class="total-col">
                {{ formatNumber(localCashFlowData.cashFlow.incomeTaxTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'income-tax-' + index"
              >
                {{
                  formatNumber(
                    (localCashFlowData.cashFlow.incomeTaxByYear || [])[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
            <!-- 其他流出 -->
            <tr>
              <td class="seq-col">2.8</td>
              <td class="item-col">其他流出</td>
              <td class="total-col">
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.operatingOtherCashOutflowTotal +
                      localCashFlowData.cashFlow
                        .investmentOtherCashOutflowTotal +
                      localCashFlowData.cashFlow.financingOtherCashOutflowTotal
                  )
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'other-cash-outflow-' + index"
              >
                {{
                  formatNumber(
                    ((localCashFlowData.cashFlow
                      .operatingOtherCashOutflowByYear || [])[index - 1] || 0) +
                      ((localCashFlowData.cashFlow
                        .investmentOtherCashOutflowByYear || [])[index - 1] ||
                        0) +
                      ((localCashFlowData.cashFlow
                        .financingOtherCashOutflowByYear || [])[index - 1] || 0)
                  )
                }}
              </td>
            </tr>

            <!-- 净现金流量 -->
            <tr>
              <td class="seq-col">3</td>
              <td class="item-col">净现金流量(1-2)</td>
              <td class="total-col">
                {{ formatNumber(localCashFlowData.cashFlow.netCashFlowTotal) }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'net-cash-flow-' + index"
              >
                {{
                  formatNumber(
                    (localCashFlowData.cashFlow.netCashFlowByYear || [])[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>

            <!-- 折现净现金流量 -->
            <tr>
              <td class="seq-col">4</td>
              <td class="item-col">折现净现金流量</td>
              <td class="total-col">
                {{
                  formatNumber(
                    localCashFlowData.cashFlow.discountedNetCashFlowTotal
                  )
                }}
              </td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'discounted-net-cash-flow-' + index"
              >
                {{
                  formatNumber(
                    (localCashFlowData.cashFlow.discountedNetCashFlowByYear ||
                      [])[index - 1] || 0
                  )
                }}
              </td>
            </tr>

            <!-- 累计折现净现金流量 -->
            <tr>
              <td class="seq-col">5</td>
              <td class="item-col">累计折现净现金流量</td>
              <td class="total-col"></td>
              <td
                class="year-col"
                v-for="index in localCashFlowData.calculationPeriod"
                :key="'cumulative-discounted-' + index"
              >
                {{
                  formatNumber(
                    (localCashFlowData.cashFlow
                      .cumulativeDiscountedNetCashFlowByYear || [])[
                      index - 1
                    ] || 0
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 指标显示区 -->
    <div class="indicators-section">
      <!-- 财务净现值 -->
      <div class="indicator-group">
        <div class="indicator-title">资本金财务净现值 (FNPV) (万元)</div>
        <div class="indicator-item">
          <div class="indicator-label">税前</div>
          <div class="indicator-value">
            {{
              formatNumber(
                localCashFlowData.cashFlow.discountedNetCashFlowBeforeTaxTotal
              )
            }}
          </div>
        </div>
        <div class="indicator-item">
          <div class="indicator-label">税后</div>
          <div class="indicator-value">
            {{
              formatNumber(
                localCashFlowData.cashFlow.discountedNetCashFlowTotal
              )
            }}
          </div>
        </div>
      </div>

      <!-- 内部收益率 -->
      <div class="indicator-group">
        <div class="indicator-title">资本金内部收益率 (FIRR) (%)</div>
        <div class="indicator-item">
          <div class="indicator-label">税前</div>
          <div class="indicator-value">
            {{ formatPercent(localCashFlowData.cashFlow.irrBeforeTax) }}
          </div>
        </div>
        <div class="indicator-item">
          <div class="indicator-label">税后</div>
          <div class="indicator-value">
            {{ formatPercent(localCashFlowData.cashFlow.irr) }}
          </div>
        </div>
      </div>

      <!-- 静态投资回收期 -->
      <div class="indicator-group">
        <div class="indicator-title">静态投资回收期 (年)</div>
        <div class="indicator-item">
          <div class="indicator-label">税前</div>
          <div class="indicator-value">
            {{
              formatNumber(localCashFlowData.cashFlow.paybackPeriodBeforeTax, 1)
            }}
          </div>
        </div>
        <div class="indicator-item">
          <div class="indicator-label">税后</div>
          <div class="indicator-value">
            {{ formatNumber(localCashFlowData.cashFlow.paybackPeriod, 1) }}
          </div>
        </div>
      </div>

      <!-- 动态投资回收期 -->
      <div class="indicator-group">
        <div class="indicator-title">动态投资回收期 (年)</div>
        <div class="indicator-item">
          <div class="indicator-label">税前</div>
          <div class="indicator-value">
            {{
              formatNumber(
                localCashFlowData.cashFlow.discountedPaybackPeriodBeforeTax,
                1
              )
            }}
          </div>
        </div>
        <div class="indicator-item">
          <div class="indicator-label">税后</div>
          <div class="indicator-value">
            {{
              formatNumber(
                localCashFlowData.cashFlow.discountedPaybackPeriod,
                1
              )
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { capitalCashFlowCalculation, zongmove } from "@/utils/comp.js";

export default {
  name: "CapitalCashFlow",
  data() {
    // 定义计算期长度
    const calcPeriod = 12;

    // 创建填充为0的数组
    const createArray = () => Array(calcPeriod).fill(0);

    return {
      localCashFlowData: {
        cashFlow: {
          // 现金流入项目
          cashInflowByYear: createArray(), // 现金流入合计
          cashInflowTotal: 0,
          operatingRevenueByYear: createArray(), // 营业收入
          operatingRevenueTotal: 0,
          subsidyIncomeByYear: createArray(), // 补贴收入
          subsidyIncomeTotal: 0,
          recoveryFixedAssetsByYear: createArray(), // 回收固定资产余值
          recoveryFixedAssetsTotal: 0,
          recoveryWorkingCapitalByYear: createArray(), // 回收流动资金
          recoveryWorkingCapitalTotal: 0,
          otherCashInflowByYear: createArray(), // 其他现金流入
          otherCashInflowTotal: 0,

          // 现金流出项目
          cashOutflowByYear: createArray(), // 现金流出合计
          cashOutflowTotal: 0,
          equityInvestmentByYear: createArray(), // 项目资本金
          equityInvestmentTotal: 0,
          debtPrincipalRepaymentByYear: createArray(), // 借款本金偿还
          debtPrincipalRepaymentTotal: 0,
          interestExpenseByYear: createArray(), // 借款利息支付
          interestExpenseTotal: 0,
          operatingCostByYear: createArray(), // 经营成本
          operatingCostTotal: 0,
          salesTaxByYear: createArray(), // 营业税金及附加
          salesTaxTotal: 0,
          vatByYear: createArray(), // 增值税
          vatTotal: 0,
          incomeTaxByYear: createArray(), // 所得税
          incomeTaxTotal: 0,
          otherCashOutflowByYear: createArray(), // 其他现金流出
          otherCashOutflowTotal: 0,

          // 净现金流量
          netCashFlowByYear: createArray(), // 净现金流量(现金流入-现金流出)
          netCashFlowTotal: 0,
          cumulativeNetCashFlowByYear: createArray(), // 累计净现金流量
          netCashFlowBeforeTaxByYear: createArray(), // 税前净现金流量
          cumulativeNetCashFlowBeforeTaxByYear: createArray(), // 税前累计净现金流量

          // 折现净现金流量
          discountedNetCashFlowByYear: createArray(), // 折现净现金流量
          discountedNetCashFlowTotal: 0, // FNPV
          cumulativeDiscountedNetCashFlowByYear: createArray(), // 累计折现净现金流量
          discountedNetCashFlowBeforeTaxByYear: createArray(), // 税前折现净现金流量
          discountedNetCashFlowBeforeTaxTotal: 0, // 税前FNPV
          cumulativeDiscountedNetCashFlowBeforeTaxByYear: createArray(), // 税前累计折现净现金流量
          利息支出ByYear: createArray(), // 借款利息支付
          利息支出Total: 0,

          // 指标
          irr: 0, // 内部收益率(FIRR)税后
          irrBeforeTax: 0, // 内部收益率(FIRR)税前
          paybackPeriod: 0, // 静态投资回收期税后
          paybackPeriodBeforeTax: 0, // 静态投资回收期税前
          discountedPaybackPeriod: 0, // 动态投资回收期税后
          discountedPaybackPeriodBeforeTax: 0, // 动态投资回收期税前
        },
        calculationPeriod: calcPeriod,
        constructionPeriod: 1,
        discountRate: 10,
      },
    };
  },
  computed: {
    ...mapState(["projectData"]),
  },

  // 启动即调用计算函数
  created() {
    // 先执行所有依赖计算，确保数据完整
    this.$nextTick(() => {
      // 执行主要计算函数，确保所有依赖数据都已准备好，跳过分年投资计划计算
      zongmove();
      // 然后再执行当前组件的计算
      const result = capitalCashFlowCalculation();
      if (result) {
        // 使用合并而不是完全替换，保留默认值
        this.localCashFlowData = {
          ...this.localCashFlowData,
          ...result,
          cashFlow: {
            ...this.localCashFlowData.cashFlow,
            ...result.cashFlow,
          },
        };
      }
    });
  },

  methods: {
    // 格式化数字显示
    formatNumber(num, decimalPlaces = 2) {
      if (num === null || num === undefined || isNaN(num)) {
        return "";
      }
      // 保留指定位数小数
      const formatted = num.toFixed(decimalPlaces);
      // 如果值为0，则显示为空
      if (parseFloat(formatted) === 0) {
        return "";
      }
      // 返回格式化后的数字，避免使用“...”
      return formatted;
    },

    // 格式化百分比显示
    formatPercent(num) {
      if (num === null || num === undefined || isNaN(num)) {
        return "";
      }
      // 保留2位小数并添加百分号
      const formatted = num.toFixed(2) + "%";
      // 如果值为0%，则显示为空
      if (parseFloat(num.toFixed(2)) === 0) {
        return "";
      }
      // 返回格式化后的百分比
      return formatted;
    },
  },
};
</script>

<style scoped>
.capital-cash-flow {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.table-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  /* 动态高度，确保表格不会超出视口 */
  min-height: 300px;
  max-height: calc(100vh - 200px);
  margin-bottom: 120px;
}

.table-scroll-area {
  flex: 1;
  overflow: auto;
  /* 支持水平和垂直滚动 */
  overflow-x: auto;
  overflow-y: auto;
  /* 确保滚动条可见 */
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

/* 美化滚动条 */
.table-scroll-area::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-scroll-area::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-scroll-area::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.table-scroll-area::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

.profit-table {
  /* 使用auto而不是fixed，让表格宽度根据内容自动调整 */
  table-layout: auto;
  border-collapse: collapse;
  font-size: 12px;
  /* 当列数少时，表格撑满容器宽度 */
  min-width: 100%;
  /* 确保表格内容不会被压缩 */
  white-space: nowrap;
}

.profit-table th,
.profit-table td {
  text-align: center;
  /* 缩小单元格边框 */
  border: 0.25px solid #e6e6e6;
  /* 设置文字不换行 */
  white-space: nowrap;
  overflow: visible;
  /* 确保不显示省略号 */
  text-overflow: clip;
}

.total-col,
.year-col {
  text-align: right !important;
  padding-right: 10px !important;
}

.profit-table thead th {
  background: #f8f9fa;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 10;
}

.seq-col {
  width: 50px;
  min-width: 50px;
}

.item-col {
  text-align: left !important;
  padding-left: 5px !important;
  padding-right: 10px !important;
}

.total-col {
  width: 100px;
  min-width: 100px;
  font-weight: 600;
}

.year-col {
  padding: 4px 2px;
  min-width: 60px;
}

/* 指标显示区样式 */
.indicators-section {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  border-top: 1px solid #dcdfe6;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  padding: 15px 20px;
  z-index: 100;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 30px;
}

/* 指标组样式 */
.indicator-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 150px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

/* 指标组悬停效果 */
.indicator-group:hover {
  background-color: #e3f2fd;
  border-color: #90caf9;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

/* 指标标题 */
.indicator-title {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
  text-align: center;
}

/* 指标项样式 */
.indicator-item {
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin-bottom: 4px;
}

.indicator-label {
  font-size: 12px;
  color: #606266;
  flex: 1;
  text-align: center;
}

.indicator-value {
  font-size: 12px;
  font-weight: 600;
  color: #303133;
  flex: 1;
  text-align: center;
}
</style>
